import React from "react";
import styles from "./UpgradePlanBanner.module.scss";
// import { ReactComponent as XIcon } from "assets/img/close.svg";
import { useAtom } from "jotai";
import { showUpgradeBannerAtom } from "showMessageMenuAtom";
import { Link } from "react-router-dom";
import Moment from "react-moment";


const UpgradePlanBanner = () => {
  const [showBanner,
    //  setShowBanner
    ] = useAtom(showUpgradeBannerAtom) as any;

  // const handleDismiss = () => {
  //   setShowBanner({ isOpen: false });
  // };

  if (!showBanner.isOpen) return null;

  return (
    <div className={`${styles.UpgradePlanBanner}`} id='UpgradePlanBanner'>
      {
        showBanner.isFreeCommunity
          ?
          <div className={styles.UpgradePlanBanner__content}>
            <div className={styles.UpgradePlanBanner__message}>
              <span className={styles.UpgradePlanBanner__special}>
                {
                  showBanner.isWithin7Days ?
                  `Your trial ends in ${showBanner.daysLeft} days. Save 30% when you upgrade by ${showBanner.upgradeBeforeDate}.`
                    // `Save 30% on Starter & Pro Plans When You Upgrade to Yearly by ${showBanner.upgradeBeforeDate}.`
                    :
                    'Upgrade now to launch your community and publish content. Start your 14-day free trial.'
                }
              </span>
            </div>
            <Link
              to={`/settings/billing/plans`}
              className={styles.UpgradePlanBanner__upgradeButton}
              // onClick={() => {
              //   if (showBanner.isWithin7Days) {
              //     localStorage.setItem('apply_30_upgrade_coupon', 'true');
              //     return
              //   }
              // }}
            >
              <button>
                {
                  showBanner.isWithin7Days ?
                    'Save 30%'
                    :
                    'Start Trial'
                }
              </button>
            </Link>
          </div>
          :
          <>
            {
              showBanner.emailNotVerified
                ?
                <div className={styles.UpgradePlanBanner__email}>
                  <div className={styles.UpgradePlanBanner__message}>
                    <span className={styles.UpgradePlanBanner__special}>
                      Please verify your email address.
                    </span>
                  </div>
                  <button
                    className={styles.UpgradePlanBanner__resendButton_email}
                    onClick={() => showBanner.fn()}
                  >
                    Verify Email
                  </button>
                </div>
                :
                <>
                  {
                    showBanner.cardChargedFailed
                      ?
                      <div className={styles.UpgradePlanBanner__content}>
                        <div className={styles.UpgradePlanBanner__message}>
                          <span className={styles.UpgradePlanBanner__special}>
                            Charging your card failed.
                          </span>
                        </div>
                        <Link
                          to={`/settings/billing`}
                          className={styles.UpgradePlanBanner__upgradeButton}
                        >
                          <button>
                            Update Card
                          </button>
                        </Link>
                      </div>
                      :

                      <div className={styles.UpgradePlanBanner__content}>
                        <div className={styles.UpgradePlanBanner__message}>
                          <span className={styles.UpgradePlanBanner__special}>
                            {
                              showBanner.isWithin7Days ?
                                `Save 30% on Starter & Pro Plans When You Upgrade to Yearly by ${showBanner.upgradeBeforeDate}.`
                                :
                                <>
                                  {
                                    showBanner.daysLeft === '1 day'
                                      ?
                                      <>1 Day</>
                                      :
                                      <span style={{ textTransform: 'capitalize' }}><Moment fromNow ago>{showBanner.trialDate}</Moment></span>
                                  }
                                  &nbsp;Left on Your Free Trial.
                                </>
                            }
                          </span>

                        </div>
                        {
                          showBanner.isWithin7Days &&
                          <Link
                            to={`/settings/billing/plans`}
                            className={styles.UpgradePlanBanner__upgradeButton}
                            // onClick={() => {
                            //   if (showBanner.isWithin7Days) {
                            //     localStorage.setItem('apply_30_upgrade_coupon', 'true');
                            //     return
                            //   }
                            // }}
                          >
                            <button>
                              Save 30%
                            </button>
                          </Link>
                        }
                      </div>
                  }
                </>
            }
          </>
      }
      {/* {
        (!showBanner.emailNotVerified || showBanner.cardChargedFailed) &&
        <button onClick={handleDismiss} className={styles.UpgradePlanBanner__dismissButton}>
          <XIcon />
        </button>
      } */}
    </div>
  );
};

export default UpgradePlanBanner;
